/**
 * Убирает скролл на всех браузера
 * @type {{hide: Window.NoScroll.hide, show: Window.NoScroll.show}}
 */
window.NoScroll = {

  /**
   * Добавить классы
   * Добавлять класс на header (hidden-index)
   */
  show: function ( header = false) {
    $('#wrapper').attr('data-pos', $(window).scrollTop());
    $('#wrapper').addClass('noscroll');
    $('#wrapper').scrollTop($('#wrapper').attr('data-pos'));

    if (header == true)
      $('.header').addClass('hidden-index');
  },

  /**
   *  Убрать классы
   */
  hide: function () {
    $("#wrapper").removeClass('noscroll');
    $(window).scrollTop($('#wrapper').attr('data-pos'));
    $('.header').removeClass('hidden-index');

  }
}